import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateFilter } from '../constants';
import { FilterItem } from '../FilterItem';

export type FilterItemsProps = {
  availableFilters: TemplateFilter[];
  selectedFilters: TemplateVisibilityValues[];
  deleteFilter: (val: TemplateVisibilityValues) => void;
  addFilter: (val: TemplateVisibilityValues) => void;
};

export const FilterItems = ({
  availableFilters,
  selectedFilters,
  deleteFilter,
  addFilter,
}: FilterItemsProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      {availableFilters.map(({ filterKey, label }) => {
        const isChecked = selectedFilters.includes(filterKey);
        return (
          <FilterItem
            key={label}
            label={t(label)}
            isChecked={isChecked}
            onChange={() =>
              isChecked ? deleteFilter(filterKey) : addFilter(filterKey)
            }
          />
        );
      })}
    </>
  );
};
